// removed by extract-text-webpack-plugin
module.exports = {"pdf-viewer-wrap":"pdfViewer__pdf-viewer-wrap___2DXHw","container-pdf":"pdfViewer__container-pdf___3mv2j","pdf-viewer":"pdfViewer__pdf-viewer___1w84M","nav-bar-pdf":"pdfViewer__nav-bar-pdf___1kT4P","pdf-viewer-wrap-extension":"pdfViewer__pdf-viewer-wrap-extension___2Mckp","download-pdf":"pdfViewer__download-pdf___1ST8j"};


//////////////////
// WEBPACK FOOTER
// ./src/pdf/pdfViewer.scss
// module id = 1256
// module chunks = 0